export default __webpack_public_path__ + "static/all-caps-dont-d3183cf3a9dcb65be45088b51fcefbb3.png";